var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.267,
    height: 39.266,
    viewBox: "0 0 29.267 29.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M16.619,5.33l7.318,7.318L8.046,28.538l-6.524.72A1.372,1.372,0,0,1,.008,27.743l.726-6.529L16.619,5.33ZM28.463,4.24,25.027.8a2.745,2.745,0,0,0-3.882,0L17.912,4.037l7.318,7.318,3.232-3.232a2.745,2.745,0,0,0,0-3.882Z",
    transform: "translate(0.001 -0.001)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlack);
export default __webpack_public_path__ + "static/media/editIconBlack.231fb5520cde347b1d956f8a2720f491.svg";
export { ForwardRef as ReactComponent };